<template>
  <Content>
    <template #body>
      <Form
        :scheme="scheme"
        :method-fetch-data="methods.fetchData"
        :method-create-data="methods.createData"
        :method-update-data="methods.updateData"
        :method-update-scheme="methods.updateScheme"
        :send-all-form="true"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Form from "@/components/Form";

import {
  getAdminId as fetchData,
  postAdmin as createData,
  patchAdminId as updateData,
} from "@/api/admins";
import defaultScheme from "@/api/schemes/admins";

export default {
  components: {
    Content,
    Form,
  },
  data() {
    return {
      scheme: defaultScheme,
      methods: {
        fetchData,
        createData,
        updateData,
      },
    };
  },
};
</script>
